import React, { useEffect, useState } from "react";
import styles from "./Recurring.module.css";
import InvestmentDetails from "./InvestmentDetails/InvestmentDetails";
import KnowledgeHub from "./KnowledgeHub/KnowledgeHub";
import DetailGraph from "./DetailedBreakdown/DetailedBreakDown";
import { useNavigate } from "react-router-dom";

const Recurring = () => {
  const [investmentAmount, setInvestmentAmount] = useState(500);
  const [expectedReturns, setExpectedReturns] = useState(1);
  const [investmentYears, setInvestmentYears] = useState(1);
  const [totalAmount, setTotalAmount] = useState(0);
  const [interestEarned, setInterestEarned] = useState(0);
  const [totalInvestment, setTotalInvestment] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className={styles.container}>
      <div
        className={styles.breadCrumb}
        onClick={() => navigate("/calculator")}
      >
        <span class="material-symbols-rounded">chevron_left</span>
        <h1>RD Calculator</h1>
      </div>

      <InvestmentDetails
        setInvestmentAmount={setInvestmentAmount}
        setExpectedReturns={setExpectedReturns}
        setInvestmentYears={setInvestmentYears}
        setTotalAmount={setTotalAmount}
        setInterestEarned={setInterestEarned}
        setTotalInvestment={setTotalInvestment}
        investmentAmount={investmentAmount}
        expectedReturns={expectedReturns}
        investmentYears={investmentYears}
        totalAmount={totalAmount}
        interestEarned={interestEarned}
        totalInvestment={totalInvestment}
      />

      <DetailGraph
        investmentAmount={investmentAmount}
        expectedReturns={expectedReturns}
        investmentYears={investmentYears}
        totalAmount={totalAmount}
        interestEarned={interestEarned}
        totalInvestment={totalInvestment}
      />

      {/* <KnowledgeHub /> */}
    </div>
  );
};

export default Recurring;
